import { yupResolver } from '@hookform/resolvers/yup';
import SearchIcon from '@mui/icons-material/Search';
import { DEBOUNCE_ONE_SECOND } from 'common/constants';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { debounce } from 'utils/debounce';
import { useStoreSelector } from 'v3/data/store';
import {
  clearFilterGroupAdmin,
  setFilterCurrentPage,
  setFilterGroupAdminName,
  setFilterGroupAdminStoreGroupId,
} from 'v3/data/store/groupAdmin/actions';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { DropdownSelectFormController } from 'v3/shared/components/Inputs/DropdownSelectFormController';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { groupsAdminSchema } from 'v3/shared/schemas/groupsAdminFilterSchema';
import { BodyLargeStyled } from 'v3/shared/typography/BodyLarge/styles';
import { AlignTitle, CardContentStyled, CardStyled } from './styles';
import { GroupAdminFilterType } from './types';

export const GroupAdminFilter = () => {
  const { allGroups } = useStoreSelector((store) => store.groupAdmin);

  const { control, setValue, clearErrors } = useForm<GroupAdminFilterType>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: undefined,
      storeGroupId: undefined,
    },
    resolver: yupResolver(groupsAdminSchema) as Resolver<GroupAdminFilterType>,
  });

  const handleOnChangeNameFilter = (name: string) => {
    debounce(
      () => {
        setFilterGroupAdminName(name!);
        setFilterCurrentPage(0);
      },
      DEBOUNCE_ONE_SECOND,
      'handleOnChangeGroupAdminNameFilter',
    );
  };

  const handleOnChangeGroupFilter = (storeGroupId: string) => {
    debounce(
      () => {
        setFilterGroupAdminStoreGroupId(storeGroupId ? [storeGroupId] : []);

        setFilterCurrentPage(0);
      },
      DEBOUNCE_ONE_SECOND,
      'handleOnChangeGroupAdminGroupFilter',
    );
  };

  const handleClearFilter = () => {
    setValue('name', undefined);
    setValue('storeGroupId', undefined);
    clearErrors();
    clearFilterGroupAdmin();
  };

  const allGroupsFormated = allGroups.map((group) => ({
    value: group.id,
    label: group.name,
  }));

  return (
    <CardStyled>
      <AlignTitle>
        <BodyLargeStyled>Filtros</BodyLargeStyled>
      </AlignTitle>
      <CardContentStyled>
        <InputFormController
          data-testid="input-name"
          formControl={control}
          formControlName="name"
          placeholder="Procurar por nome"
          fullWidth
          onChangeInput={handleOnChangeNameFilter}
          startAdornmentIcon={SearchIcon}
        />
        <DropdownSelectFormController
          data-testid="select-form-controller-group"
          formControl={control}
          formControlName="storeGroupId"
          label="Grupo"
          selectValues={allGroupsFormated}
          onChangeSelect={handleOnChangeGroupFilter}
        />

        <TextButton data-testid="clean" text="Limpar" handleClick={handleClearFilter} />
      </CardContentStyled>
    </CardStyled>
  );
};
